/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../src/app/order/wizard/orderbilling.component';
import * as i6 from '@angular/router';
import * as i7 from '../../../../../src/app/modules/features/flag.service';
import * as i8 from '../../../../../src/app/order/order.service';
import * as i9 from '../../../../../src/app/order/currentOrder.service';
import * as i10 from '../../../../../src/app/order/orderValidation';
import * as i11 from '../../../../../src/app/mixpanel/mixpanel.service';
var styles_OrderBillingComponent = [];
export var RenderType_OrderBillingComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_OrderBillingComponent, data: {} });
function View_OrderBillingComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class',
                'add']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['id', 'file'], ['type',
                'file']], [[2, 'ng-untouched', null], [2, 'ng-touched', null],
            [2, 'ng-pristine', null], [2, 'ng-dirty', null], [2, 'ng-valid',
                null], [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null, 'change'], [null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 3)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 3)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 3)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('change' === en)) {
                var pd_4 = (_co.attachFile($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_5 = ((_co.order.POfile = $event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0,
                'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', ''], ['for', 'file']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.order.POfile;
        _ck(_v, 5, 0, currVal_7);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 7).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 7).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 7).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 7).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 7).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 7).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 7).ngClassPending;
        _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = i0.ɵunv(_v, 10, 0, i0.ɵnov(_v, 11).transform('ORDER.FORM.PARTS.LABEL.FILE_ADD_PO'));
        _ck(_v, 10, 0, currVal_8);
    });
}
function View_OrderBillingComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class',
                'loading']], null, null, null, null, null))], null, null);
}
function View_OrderBillingComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 5, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                                        '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'div', [['class', 'remove']], null, [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = ((_co.order.POfileName = null) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), (_l()(), i0.ɵted(null, ['\n                                                ',
            ' : ', '\n                                        '])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('ORDER.FORM.PARTS.LABEL.FILE_REMOVE'));
        var currVal_1 = _co.order.POfileName;
        _ck(_v, 3, 0, currVal_0, currVal_1);
    });
}
function View_OrderBillingComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 10, 'div', [['class',
                'col-xs-12 file-select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderBillingComponent_2)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderBillingComponent_3)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderBillingComponent_4)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (!_co.order.POfileName && !_co.uploadingFile);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.uploadingFile;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.order.POfileName;
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
export function View_OrderBillingComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['    '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'text-c']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'h3', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['3. ', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n\n    '])),
        (_l()(), i0.ɵeld(0, null, null, 151, 'div', [['class', 'content-inner-wizard']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'message-wizard']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 2, 'p', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵeld(0, null, null, 141, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n            '])),
        (_l()(), i0.ɵeld(0, null, null, 138, 'div', [['class', 'col-lg-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n\n                '])), (_l()(), i0.ɵeld(0, null, null, 131, 'div', [['class', 'wizard content-form']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n\n                    '])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'ul', [['class', 'check-steps']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 2, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 1, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i4.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n\n                    '])), (_l()(), i0.ɵeld(0, null, null, 120, 'div', [['class', 'content']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 33, 'div', [['class', 'row no-margin form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'col col-bubble']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'bubble-step']], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['1'])), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'col-inputs']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' *'])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control'],
            ['name', 'po_number'], ['type', 'text']], [[8, 'placeholder', 0], [2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
            [null, 'keyup'], [null, 'blur'], [null, 'input'], [null,
                'compositionstart'], [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 52)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 52).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 52)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 52)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.order.PurchaseOrderNumber = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (('keyup' === en)) {
                var pd_5 = (_co.checkField($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
                var pd_6 = (_co.checkField($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 2, 'span', [['class', 'help-block']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderBillingComponent_1)),
        i0.ɵdid(16384, null, 0, i4.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'row no-margin form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'div', [['class', 'col col-bubble']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' '])), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'col-inputs']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'col col-xs-12 form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control'],
                ['name', 'promo_code'], ['type', 'text']], [[8, 'placeholder', 0], [2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
                [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
                [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 83)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (i0.ɵnov(_v, 83).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (i0.ɵnov(_v, 83)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (i0.ɵnov(_v, 83)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_4 = ((_co.order.PromoCode = $event) !== false);
                    ad = (pd_4 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'row no-margin form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'col col-bubble']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 12, 'div', [['class', 'col col-xs-12 form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 2, 'label', [['class', 'control-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService,
            i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                    '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'textarea', [['class', 'form-control'],
            ['name', 'question_comments'], ['rows', '4']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 106)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 106).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 106)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 106)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.order.QuestionComment = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n\n\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 33, 'div', [['class', 'row no-margin']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'col col-bubble']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 28, 'div', [['class', 'col-inputs']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 25, 'div', [['class', 'col col-xs-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                     '])),
        (_l()(), i0.ɵeld(0, null, null, 22, 'div', [['class', 'order_buttons_holder']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 19, 'ul', [['class', 'order_buttons']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 5, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 4, 'a', [['class', 'btn-add btn-icon'], ['routerLink',
                '../address']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 131).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(671744, null, 0, i6.RouterLinkWithHref, [i6.Router, i6.ActivatedRoute, i4.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class',
                'fa-pt pt-b-arr']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵeld(0, null, null, 3, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 2, 'button', [['class', 'btn btn-default btn-cancel extra-pad btn-lg']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.resetForm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                            '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵeld(0, null, null, 3, 'button', [['class', 'btn extra-pad btn-lg btn-primary'],
            ['routerLink', '../shipping']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 143).onClick() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i6.RouterLink, [i6.Router, i6.ActivatedRoute, [8, null], i0.Renderer2, i0.ElementRef], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n\n\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                 '])),
        (_l()(), i0.ɵeld(0, null, null, 2, 'div', [['class', 'from-required-field']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                  * ', '\n                '])),
        i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n\n        '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(),
            i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.getPurchaseOrderNumberFieldsClass();
        _ck(_v, 28, 0, currVal_2);
        var currVal_12 = 'po_number';
        var currVal_13 = _co.order.PurchaseOrderNumber;
        _ck(_v, 54, 0, currVal_12, currVal_13);
        var currVal_15 = _co.isFilePOActive;
        _ck(_v, 65, 0, currVal_15);
        var currVal_25 = 'promo_code';
        var currVal_26 = _co.order.PromoCode;
        _ck(_v, 85, 0, currVal_25, currVal_26);
        var currVal_35 = 'question_comments';
        var currVal_36 = _co.order.QuestionComment;
        _ck(_v, 108, 0, currVal_35, currVal_36);
        var currVal_39 = '../address';
        _ck(_v, 131, 0, currVal_39);
        var currVal_43 = '../shipping';
        _ck(_v, 143, 0, currVal_43);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵunv(_v, 4, 0, i0.ɵnov(_v, 5).transform('ORDER.FORM.BILLING.TITLE'));
        _ck(_v, 4, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 13, 0, i0.ɵnov(_v, 14).transform('ORDER.FORM.BILLING.MESSAGE'));
        _ck(_v, 13, 0, currVal_1);
        var currVal_3 = i0.ɵunv(_v, 48, 0, i0.ɵnov(_v, 49).transform('ORDER.FORM.BILLING.LABEL.PO_NUMBER'));
        _ck(_v, 48, 0, currVal_3);
        var currVal_4 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 51, 0, i0.ɵnov(_v, 57).transform('ORDER.FORM.BILLING.PLACEHOLDER.PO_NUMBER')), '');
        var currVal_5 = i0.ɵnov(_v, 56).ngClassUntouched;
        var currVal_6 = i0.ɵnov(_v, 56).ngClassTouched;
        var currVal_7 = i0.ɵnov(_v, 56).ngClassPristine;
        var currVal_8 = i0.ɵnov(_v, 56).ngClassDirty;
        var currVal_9 = i0.ɵnov(_v, 56).ngClassValid;
        var currVal_10 = i0.ɵnov(_v, 56).ngClassInvalid;
        var currVal_11 = i0.ɵnov(_v, 56).ngClassPending;
        _ck(_v, 51, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11);
        var currVal_14 = i0.ɵunv(_v, 60, 0, i0.ɵnov(_v, 61).transform('ORDER.FORM.FIELD_REQUIRED'));
        _ck(_v, 60, 0, currVal_14);
        var currVal_16 = i0.ɵunv(_v, 79, 0, i0.ɵnov(_v, 80).transform('ORDER.FORM.BILLING.LABEL.PROMO_CODE'));
        _ck(_v, 79, 0, currVal_16);
        var currVal_17 = i0.ɵinlineInterpolate(1, '', i0.ɵunv(_v, 82, 0, i0.ɵnov(_v, 88).transform('ORDER.FORM.BILLING.PLACEHOLDER.PROMO_CODE')), '');
        var currVal_18 = i0.ɵnov(_v, 87).ngClassUntouched;
        var currVal_19 = i0.ɵnov(_v, 87).ngClassTouched;
        var currVal_20 = i0.ɵnov(_v, 87).ngClassPristine;
        var currVal_21 = i0.ɵnov(_v, 87).ngClassDirty;
        var currVal_22 = i0.ɵnov(_v, 87).ngClassValid;
        var currVal_23 = i0.ɵnov(_v, 87).ngClassInvalid;
        var currVal_24 = i0.ɵnov(_v, 87).ngClassPending;
        _ck(_v, 82, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24);
        var currVal_27 = i0.ɵunv(_v, 102, 0, i0.ɵnov(_v, 103).transform('ORDER.FORM.BILLING.LABEL.COMMENTS'));
        _ck(_v, 102, 0, currVal_27);
        var currVal_28 = i0.ɵnov(_v, 110).ngClassUntouched;
        var currVal_29 = i0.ɵnov(_v, 110).ngClassTouched;
        var currVal_30 = i0.ɵnov(_v, 110).ngClassPristine;
        var currVal_31 = i0.ɵnov(_v, 110).ngClassDirty;
        var currVal_32 = i0.ɵnov(_v, 110).ngClassValid;
        var currVal_33 = i0.ɵnov(_v, 110).ngClassInvalid;
        var currVal_34 = i0.ɵnov(_v, 110).ngClassPending;
        _ck(_v, 105, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34);
        var currVal_37 = i0.ɵnov(_v, 131).target;
        var currVal_38 = i0.ɵnov(_v, 131).href;
        _ck(_v, 130, 0, currVal_37, currVal_38);
        var currVal_40 = i0.ɵunv(_v, 133, 0, i0.ɵnov(_v, 134).transform('ORDER.FORM.PREVIOUS'));
        _ck(_v, 133, 0, currVal_40);
        var currVal_41 = i0.ɵunv(_v, 138, 0, i0.ɵnov(_v, 139).transform('ORDER.FORM.RESET'));
        _ck(_v, 138, 0, currVal_41);
        var currVal_42 = !_co.isValid();
        _ck(_v, 142, 0, currVal_42);
        var currVal_44 = i0.ɵunv(_v, 144, 0, i0.ɵnov(_v, 145).transform('ORDER.FORM.CONTINUE'));
        _ck(_v, 144, 0, currVal_44);
        var currVal_45 = i0.ɵunv(_v, 155, 0, i0.ɵnov(_v, 156).transform('ORDER.FORM.REQUIRED_FIELD'));
        _ck(_v, 155, 0, currVal_45);
    });
}
export function View_OrderBillingComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-orderbilling', [], null, null, null, View_OrderBillingComponent_0, RenderType_OrderBillingComponent)), i0.ɵdid(114688, null, 0, i5.OrderBillingComponent, [i7.FlagService, i8.OrderService, i3.TranslateService, i9.CurrentOrderService, i10.OrderValidation,
            i11.MixpanelService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var OrderBillingComponentNgFactory = i0.ɵccf('cx-orderbilling', i5.OrderBillingComponent, View_OrderBillingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=orderbilling.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/order/wizard/orderbilling.component.ngfactory.js
// module id = 1193
// module chunks = 0